// src/models/monedaModel.js

import pb from '../lib/pocketbase';

export async function getMonedas(page, perPage) {
  return await pb.collection('moneda').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false // Desactiva la auto-cancelación
  });
}

export async function createMoneda(moneda) {
  return await pb.collection('moneda').create(moneda);
}

export async function updateMoneda(id, moneda) {
  return await pb.collection('moneda').update(id, moneda);
}

export async function deleteMoneda(id) {
  return await pb.collection('moneda').delete(id);
}
